import { AppRouteProps } from "@bsm/component";
import React from "react";
import { ProjectTimeOffEventCreateEventRoutes } from "../create/ProjectTimeOffEventCreateEventRoutes";
import { HolidayViewerRoutes } from "./views/viewer/HolidayViewerRoutes";
const CalendarContainer = React.lazy(() => import("./container/CalendarContainer"));

export const ProjectCalendarRoutes: Array<AppRouteProps> = [
    {
        path: "calendar",
        title: "std_calendar",
        element: <CalendarContainer id="CalendarContainer" view="dayGridMonth" />,
        roles: ["TIMEOFF"],
        children: [
            ...ProjectTimeOffEventCreateEventRoutes,
            ...HolidayViewerRoutes
            // ...ProjectTimeOffCreateLeavingRoutes,
            // ...ProjectCalendarCardDetailsRoutes,
            // ...CalendarPlanningRoutes
        ]
    },
];
